import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Link } from 'react-router-dom';
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';
import DownloadBtnSaleInvoicePdf from "../../Invoices/Sale/DownloadBtnSaleInvoicePdf";
import PrintBtnSaleInvoicePdf from "../../Invoices/Sale/PrintBtnSaleInvoicePdf";
import DownloadBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/DownloadBtnSaleReturnInvoicePdf";
import PrintBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/PrintBtnSaleReturnInvoicePdf";

let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";
let _businessSetting = {};

if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
      label: '#',
      field: 'srNo',
      width: 20,
      attributes: {
      'aria-controls': 'DataTable',
      'aria-label': '#',
      },
  },
  {
      label: 'Date',
      field: 'invoice_date',
      width: 150,
      attributes: {
      'aria-controls': 'DataTable',
      'aria-label': 'Date',
      },
  },
  {
    label: "Due Date",
    field: "due_date",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Due Date",
    },
  },
  {
    label: "Order No.",
    field: "invoice_no",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Order No.",
    },
  },
  {
    label: "Party Name",
    field: "party_name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Name",
    },
  },
  {
    label: "Type",
    field: "payment_type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Type",
    },
  },
  {
      label: 'Amount',
      field: 'total_amount',
      width: 150,
      attributes: {
      'aria-controls': 'DataTable',
      'aria-label': 'Amount',
      },
  },
  {
      label: 'Balance Due',
      field: 'balance',
      width: 150,
      attributes: {
      'aria-controls': 'DataTable',
      'aria-label': 'Balance Due',
      },
  },
  {
      label: 'Status',
      field: 'status',
      width: 150
  },
  {
      label: 'Action',
      field: 'action',
      width: 100,
  }
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;

export default class dayBookReportPanel extends Component {
  constructor(props){
    super(props);
    
    let _UserSession = localStorage.getItem('vs_UserSession');
    if(_UserSession!=undefined || _UserSession!=null)
    {
        _UserSession = JSON.parse(_UserSession);
        _signingId = _UserSession.loginId;
        _businessId = _UserSession.tokenKey;
        _businessSetting = _UserSession.businessSetting;
        if (_businessSetting!=undefined || _businessSetting!=null) {
        
        }
    }

    let _companySession = localStorage.getItem('vs_UserCompanySession');
    if(_companySession!=undefined || _companySession!=null)
    {
        _companySession = JSON.parse(_companySession);
        _businessId = _companySession.business_id;
        _companyId = _companySession.company_id;
    }
    this.state = {
        buttonTitle:'Add Sale',
        isLoaded : true,
        isPdfLoading: false,
        transactionArray :[],
        transactionArrayFilter:[],
        businessId:_businessId,
        company_id:_companyId,
        userId : _signingId,
        name :  null,

        paidAmount:0,
        unpaidAmount:0,   
        typeFilter : 'Both',
        total:0,

        pageCount : 10,
        page : 1,
        totalCount  : 0,
        pageShow  : 0,
        setPage : 1,
        searchInvNo : '',

        errors: {
            name : '',
        }
    }
  }

  async componentDidMount() {
    this.getSaleListData(this.state.activeTransactionKey);
  }

  getSaleListData(_page,searchInvSend,pageCount){
      let _transArray = [];

      let _paidAmt = 0;
      let _unpaidAmt = 0;
      let _totalAmt = 0;

      const requestData = JSON.stringify({
          business_id:this.state.businessId,
          company_id:this.state.company_id,
          type:"SALE ORDER",
          pageCount:pageCount,
          search_inv_no:searchInvSend,
          page:1,
          pageCount: 10,
          search_inv_no: ""
      });

      PostData(global.userSalePurchaseOrderReportList, requestData,'POST').then((result) => {
          let responseJson = result;
          if(responseJson.success == false)
          {  
              this.setState({transactionArrayFilter:_transArray,itemArray:_transArray,isLoaded:true,paidAmount:_paidAmt,unpaidAmount:_unpaidAmt,total:_totalAmt,isLoaded: true});
          }
          else
          {   
              if (responseJson.response) {
                  _transArray = responseJson.response;
                  _transArray.map((itm, i) =>{
                      if(itm.payment_paid == 'UNPAID'){
                          _unpaidAmt = parseFloat(_unpaidAmt) + parseFloat(itm.total_amount);
                      }
                      else{
                          _paidAmt = parseFloat(_paidAmt) + parseFloat(itm.total_amount);
                      }
                      //itm.payType = 'Sale Order';
                      
                      itm.payType = 'Order Open';
                      if(itm.open_status == 0)
                      {
                          itm.payType = 'Order Open';
                      }
                      else if(itm.open_status == 1){
                          itm.payType = 'Order Completed';
                      }
                  });
              } 
              _totalAmt = parseFloat(_paidAmt) + parseFloat(_unpaidAmt);
              _transArray.sort((a, b) => b.added_on - a.added_on);
              this.setState({transactionArrayFilter:_transArray,itemArray:_transArray,isLoaded:true,paidAmount:_paidAmt,unpaidAmount:_unpaidAmt,total:_totalAmt,totalCount:responseJson.totalCount,pageShow:responseJson.pageShow});
          }             
      })
      .catch(error => this.setState({ error, isLoaded: false }));
  }
 
  loadTranscListing(){
      let dataList = [];
      let rows = [];
      if(this.state.isLoaded == true)
      {
          let _transDetails = this.state.transactionArrayFilter;
          if(_transDetails.length > 0){

              let _filterType = 'Both';
              if(this.state.typeFilter == 'Order Open')
              {
                  _filterType = 'Order Open';
              }
              else if(this.state.typeFilter == 'Order Completed'){
                  _filterType = 'Order Completed';
              }
              let _i = 0;
              _transDetails.map((value,index) => {
                  _i++
                  let _trans_duplicate_normal = value.trans_duplicate_normal ? value.trans_duplicate_normal : ''; 
                  let _type = "&tType="+value.type;
                  let _status = <span className="text-info">Order Open</span>;
                  let _currentDate = moment().format('YYYY-MM-DD');
                  var msDiff = new Date(value.due_date).getTime() - new Date().getTime();    //Future date - current date
                  var daysTill = Math.floor(msDiff / (1000 * 60 * 60 * 24));
                  
                  if(value.saleOrderStatus == 'Order Overdue' && _businessSetting.DueDatesPaymentTerms == 1){
                      _status = <span className="text-danger">Order Overdue </span>;
                  }   
                  // if(daysTill < 0)
                  // {
                  //     _status = <span className="text-danger">Order Overdue</span>;
                  // }
                
                  let _action = <a href={global.webUrl+'business/add-sale/?auth='+value.id+'&tType=ORDER'}><span className="btn btn-sm btn-secondary" >Convert To Sale</span></a>;
                  if(_trans_duplicate_normal === 'Duplicate'){
                      _action = 'NA';
                  }
                  let _ttype = 'Sale';
                  if(value.type!='SALE ORDER'){
                    _ttype = 'Purchase';
                  }
                  if(value.open_status == '1' || value.open_status == '2'){
                      _status = <span className="text-successDark">Order Completed</span>;
                      _action = <span className="text-secondary">{_ttype} Invoice No. {value.against_invoice_no}</span>;
                      if(value.open_status == "2"){
                          _action = (<span className="text-secondary"><b>Convert to sale is deleted</b></span>);
                        }
                  }
                  
                  let _pageAK = this.state.setPage;
                  
                  let _showDupL = '';
                  if(_trans_duplicate_normal == 'Duplicate'){
                      _showDupL = ' (Duplicate)';
                  }
                  let showDateTime = moment(value.invoice_date).format('DD MMM, YY');
                  if (_businessSetting.Tran_AddTime == 1) {
                      showDateTime = moment(value.invoice_date).format('DD MMM, YY') + " " + value.invoice_time;
                  } 
                  let _showInv = value.customPrefix+' #'+value.invoice_no_web;
                  if(_filterType == value.payType){
                      
                      rows.push({
                          srNo: ((_pageAK - 1) * this.state.pageCount) + _i,//value.srNo,//_xx,
                          invoice_date: showDateTime,
                          due_date:moment(value.due_date).format('DD MMM, YY'),
                          invoice_no:_showInv+_showDupL,
                          party_name:value.party_name,
                          payment_type: value.type,
                          total_amount:numberFormat(value.total_amount),
                          balance: numberFormat(value.balance),
                          status: _status,
                          action: _action
                      });
                  }
                  else if(_filterType == 'Both')
                  {
                      rows.push({
                          srNo: ((_pageAK - 1) * this.state.pageCount) + _i,//value.srNo,//_xx,
                          invoice_date: showDateTime,
                          due_date: moment(value.due_date).format('DD MMM, YY'),
                          invoice_no:_showInv+_showDupL,
                          party_name:value.party_name,
                          payment_type: value.type,
                          total_amount:numberFormat(value.total_amount),
                          balance: numberFormat(value.balance),
                          status: _status,
                          action: _action
                      });
                  }
              });
          }
      }

      if (rows) {
          dataList = {
              columns: columns,
              rows: rows
          };
      }
      return dataList;
  }

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData();
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }


  exportData = (event) =>{
    let _itemDetails = this.state.transactionArrayFilter;
    try {
      let totalAmount = 0;
      _itemDetails.map((data) => {
        totalAmount += parseFloat(data.total_amount);
      });

      _itemDetails = _itemDetails.map((data) => {
        let _showInv = data.customPrefix+' #'+data.invoice_no_web;
        let showDateTime = moment(data.invoice_date).format('DD MMM, YY');
        if (_businessSetting.Tran_AddTime == 1) {
            showDateTime = moment(data.invoice_date).format('DD MMM, YY') + " " + data.invoice_time;
        } 
        let newData = {
          'Invoice Date': showDateTime,
          'Due Date': moment(data.due_date).format('DD MMM, YY'),
          'Invoice No.': _showInv,
          'Party Name': data.party_name,
          'Payment Type': data.type,
          'Total Amount': numberFormat(data.total_amount),
          'Balance': numberFormat(data.balance),
        }
         return newData;
      });

      let totalAmountRow = {
          'Invoice Date': '',
          'Due Date': '',
          'Invoice No.': '',
          'Party Name': '',
          'Payment Type': '',
          'Total Amount': '',
          'Balance': ''
      };

      _itemDetails.push({});
      _itemDetails.push(totalAmountRow);
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Sale Purchase Order Report");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_sale_purchase_order_report_'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Stock Summary</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-9">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-3">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <Link onClick={this.exportData} >
                                  <div className="text-info">
                                    <i className="fa fa-file-excel-o"></i>
                                  </div>
                                  <div className="font-size-sm text-muted">
                                        Excel Export
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Transactions</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                                            <i className="fa fa-plus-circle"></i> Add Sale
                                        </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100]}
                      entries={25}
                      pagesAmount={4}
                      span
                      pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
